import React from 'react'
import Sparkline from './spark-line'
import Median from './median'
import Marker from './marker'
import colors from '../colors'

class Trendline extends React.PureComponent {
  static defaultProps = {
    stroke: colors.defaultGray,
    curve: n => n,
    points: []
  }

  render() {
    const { stroke, curve, marker, median, points, scaleX, scaleY } = this.props

    if (!curve || points.length <= 0) {
      // Do not render if there is no curve
      return null
    }

    var coords = points.map(function(p) {
      return { x: p.x, y: curve(p.x) }
    })

    return (
      <g className="trend-line">
        <Median
          value={median}
          scaleX={scaleX}
          scaleY={scaleY}
          stroke={stroke}
          strokeWidth="2"
          strokeDasharray="2 3"
        />
        <Sparkline
          points={coords}
          scaleX={scaleX}
          scaleY={scaleY}
          stroke={stroke}
          strokeWidth="2"
          strokeDasharray="6 3"
        />
        <Marker point={marker} scaleX={scaleX} scaleY={scaleY} />
      </g>
    )
  }
}

export default Trendline



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/trend-line.js